module.exports = __webpack_public_path__ + "static/sanbikinokobuta_w600xh400-fa56c6bb91f55392951d0bfc6308b51d.jpg";